import {
  Box,
  Button,
  Icon,
  Modal,
  Switch
} from '@platform/ui-library';
import { RootRoute } from '@app/const';
import { navigateToRoute } from '@app/utilities';
import { useServices } from '../../../hooks';
import { useDiagnoseDesign } from './use-diagnose-design';
import styles from '../dialogs.module.scss';

export function DiagnoseDesignDialog() {
  const {
    close,
    checkResults,
    fix,
    fixResults,
    setShouldFix,
    isOpen
  } = useDiagnoseDesign();
  const { errorMessageService } = useServices();

  const onComplete = () => {
    close();
    navigateToRoute(RootRoute.save);
  };

  if (!isOpen) {
    return null;
  }

  const title = (fixResults) ? 'Results' : (
    <>
      <Icon icon="warningColor" />
      <strong>{(checkResults.length === 1) ? 'One Issue' : `${checkResults.length} Issues`}</strong>
      {' '}
      Found in the Design
    </>
  );

  return (
    <Modal handleClose={() => null} isOpen={true}>
      <Box theme="noPadding" className={styles.container}>
        <div className={styles.header}>
          <h4>{title}</h4>
        </div>
        <div className={styles.content}>
          {(!fixResults) ? (
            <>
              <p>
                It is recommended to save any changes you have made, run all the automatic updates,
                then save the design again to keep the automatic fixes separate from your changes.
              </p>
              <div className={styles.grid}>
                <div>
                  <div>Issue</div>
                  <div>Fix</div>
                </div>
                {checkResults.map(({ message, shouldFix }, index) => (
                  <div key={index}>
                    <p>{message}</p>
                    <Switch
                      checked={shouldFix}
                      onChange={() => {
                        setShouldFix(index, !shouldFix);
                      }}
                    />
                  </div>
                ))}
              </div>
              <div className={styles.actions}>
                <Button onClick={close} theme="outline">
                  Ignore
                </Button>
                <Button
                  onClick={() => {
                    const someChecked = checkResults.some(({ shouldFix }) => {
                      return shouldFix;
                    });
                    if (someChecked) {
                      fix();
                    } else {
                      errorMessageService.addError('Please select which fixes you wish to apply.');
                    }
                  }}
                  theme="outlineHighlight"
                >
                  Fix Selected
                </Button>
              </div>
            </>
          ) : (
            <>
              <p>{'Update completed. It\'s recommended to save the design before continuing.'}</p>
              {fixResults.map(({ message, error }, i) => (
                <div
                  key={i}
                  className={styles.listItem}
                  data-error={error}
                >
                  <Icon icon={(!error) ? 'successColor' : 'errorColor'} />
                  {message}
                </div>
              ))}
              <div className={styles.actions}>
                <Button onClick={close} theme="outline">
                  Close
                </Button>
                <Button onClick={onComplete}>Go to the Save Page</Button>
              </div>
            </>
          )}
        </div>
      </Box>
    </Modal>
  );
}
